const INDEX_ITEMS = [
  { id: 1, title: '动作冒险', count: '1.2万部', icon: 'ri-sword-line', desc: '热血激战、极限追凶，肾上腺素飙升的观影体验' },
  { id: 2, title: '科幻奇幻', count: '8,600部', icon: 'ri-rocket-2-line', desc: '探索宇宙奥秘，打开想象力边界的视觉奇观' },
  { id: 3, title: '喜剧搞笑', count: '9,200部', icon: 'ri-emotion-laugh-line', desc: '轻松解压，欢乐不停，治愈每一天的好心情' },
  { id: 4, title: '悬疑惊悚', count: '6,800部', icon: 'ri-ghost-line', desc: '烧脑反转、高能预警，挑战你的推理极限' },
  { id: 5, title: '爱情剧情', count: '1.1万部', icon: 'ri-heart-line', desc: '感人至深的情感故事，触动心灵的光影诗篇' },
  { id: 6, title: '纪录片', count: '5,400部', icon: 'ri-earth-line', desc: '真实世界的影像记录，自然、历史与人文探索' },
  { id: 7, title: '动画动漫', count: '7,500部', icon: 'ri-paint-brush-line', desc: '全年龄段动画盛宴，从经典到新番精彩纷呈' },
  { id: 8, title: '经典怀旧', count: '4,300部', icon: 'ri-time-line', desc: '8090年代经典老片，高清修复重温旧日时光' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影片分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            覆盖全类型的免费电影大全，无论你喜欢什么题材，都能在这里找到心仪的影片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="bg-background-50 rounded-xl p-5 border border-background-200/30 hover:border-primary-500/15 hover:bg-background-50/80 transition-all duration-300 cursor-pointer group no-underline"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/10 transition-colors">
                  <i className={`${item.icon} text-primary-500 text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800">{item.title}</h3>
                  <span className="text-[11px] text-foreground-400">{item.count}</span>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}